import { createFileRoute } from '@tanstack/react-router';
import { UnsubscribeWeeklyEmail } from '@amber-ui/core';

export const Route = createFileRoute('/unsubscribe_weekly_email/$email/$user_id')({
  component: UnsubscribeWeeklyEmail,
});
